import {
  SR_API_ACTION_HOUSEHOLD_MARK_APPLICATIONS_ACCEPTED,
} from 'api/actionTypes';

import askForMobileAppReview from 'client/actions/MobileApp/askForReview';

export default async function approveApplications({
  state,
  apiClient,
}, {
  householdListingId,
  whoCollectsSecurityDepositPetFees,
  securityDepositCollectionInstructions,
  srStripeAccountId,
  updateHouseholdToActive,
}) {
  return apiClient.postWithState({
    action: SR_API_ACTION_HOUSEHOLD_MARK_APPLICATIONS_ACCEPTED,
    queryId: String(householdListingId),
    state: state,
    payload: {
      householdListingId,
      whoCollectsSecurityDepositPetFees,
      securityDepositCollectionInstructions,
      srStripeAccountId,
      updateHouseholdToActive,
    },
    onSuccess: () => {
      askForMobileAppReview({ state });
    },
  });
}
